import { UID2 } from "../../../lib/uid2-sdk-2.0.0";

export function createUid2Sdk() {
  return new UID2();
}
